import {
  PHONE_CANDIDATE,
  canonicalBrazilianPhone,
} from 'shared/helpers/phoneLinks';

// Turns Brazilian phone numbers in plain text into links carrying the number in data-phone,
// which the dashboard's message bubble catches to open "new conversation" with it. The href
// is a tel: link so the text still means something wherever the click is not caught.

const phoneTokens = (text, state) => {
  const tokens = [];
  let last = 0;

  [...text.matchAll(new RegExp(PHONE_CANDIDATE.source, 'g'))].forEach(match => {
    const phone = canonicalBrazilianPhone(match[0]);
    if (!phone) return;

    if (match.index > last) {
      const before = new state.Token('text', '', 0);
      before.content = text.slice(last, match.index);
      tokens.push(before);
    }

    const open = new state.Token('link_open', 'a', 1);
    open.attrs = [
      ['href', `tel:${phone}`],
      ['data-phone', phone],
    ];
    open.markup = 'phone';
    open.info = 'auto';

    const label = new state.Token('text', '', 0);
    label.content = match[0];

    const close = new state.Token('link_close', 'a', -1);
    close.markup = 'phone';
    close.info = 'auto';

    tokens.push(open, label, close);
    last = match.index + match[0].length;
  });

  if (!tokens.length) return null;

  if (last < text.length) {
    const after = new state.Token('text', '', 0);
    after.content = text.slice(last);
    tokens.push(after);
  }
  return tokens;
};

export default function phonePlugin(md) {
  // After text_join, so an escaped character never splits a number across two tokens.
  md.core.ruler.after('text_join', 'phone_links', state => {
    state.tokens.forEach(blockToken => {
      if (blockToken.type !== 'inline' || !blockToken.children) return;

      let insideLink = 0;
      blockToken.children = blockToken.children.flatMap(token => {
        if (token.type === 'link_open') insideLink += 1;
        if (token.type === 'link_close') insideLink -= 1;
        if (token.type !== 'text' || insideLink > 0) return [token];

        return phoneTokens(token.content, state) || [token];
      });
    });
  });
}
